<div class="container-fluid p-0 m-0">
    <div class="row w-100 m-0 p-2">
            <div class="col-lg-5 col-md-6  row m-0 bg-white shadow p-1">
                <div class="col-md my-auto">
                    <div *ngIf="dataOverallAds==0" class="font-weight-bold text-center my-auto text-uppercase"><h4>NO DATA FOUND</h4></div>
                    <canvas baseChart class="chart" *ngIf="dataOverallAds!=0"
                    [data]="ChartData"
                    [labels]="ChartLabels"
                    [colors]="Colors"  
                    [options]="Options"
                    [chartType]="ChartType">              
                    </canvas>

                </div>
                <div class="col-md m-0 p-0 my-auto chart-text">
                    <table  class="table table-borderless table-nowrap">
                        <tbody>
                            <tr>
                                <td class=""><p  class="mb-0 text-blue text-uppercase">All Activity</p></td>
                                <td><p class="text-blue mb-0">{{total_All_Activity}}</p></td>
                            </tr>
                            <tr>
                                <td><p class="mb-0 text-uppercase">Instore</p></td>
                                <td><p class="mb-0">{{total_Instore}}</p></td>
                            </tr>
                            <tr>
                                <td><p class="mb-0 text-uppercase">Hoarding</p></td>
                                <td><p class="mb-0">{{total_Hoardings}}</p> </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="chart-text">
                        <div class="d-flex m-0 p-0">
                            <span class="dot-blue my-auto"></span><p class="ml-2 mb-0">UPCOMING ACTIVITY</p>
                        </div>
                        <div class="d-flex m-0 p-0">
                            <span class="dot-green my-auto"></span><p class="ml-2 mb-0">NEW ACTIVITY</p>
                        </div>
                        <div class="d-flex m-0 p-0">
                            <span class="dot-yellow my-auto"></span><p class="ml-2 mb-0">CURRENT ACTIVITY</p>
                        </div>
                        <div class="d-flex m-0 p-0">
                            <span class="dot-orange my-auto"></span><p class="ml-2 mb-0">EXPIRING ACTIVITY</p>
                        </div>
                        <div class="d-flex m-0 p-0">
                          <span class="dot-red my-auto"></span><p class="ml-2 mb-0">EXPIRED ACTIVITY</p>
                         </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-7 col-md-6 row m-0 p-1">

                <div class="col-lg-4 m-0 p-1">
                    <div class="card m-0 p-0 shadow h-100 pointer" (click)="getUpcomingAds()">
                        <div class="">
                            <div class="row m-0 p-0 no-gutters align-items-center">
                                <div class="col p-2 mr-2 border-left-primary">
                                    <div class="font-weight-bold text-uppercase">UpComing Activity</div>
                                    <div class="h3 mb-0 font-weight-bold" *ngIf="upComingAds">{{upComingAds.instore+upComingAds.hoarding}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer p-0">
                            <div class="row m-0 p-2 text-center">
                                <div class="col">
                                    <p class="m-0 text-gray-800 font-weight-bold" *ngIf="upComingAds">{{upComingAds.instore}}</p>
                                    <span class="font-sm my-0 fono">INSTORE</span>
                                </div>
                                <div class="col">
                                    <p class="m-0 text-gray-800 font-weight-bold" *ngIf="upComingAds">{{upComingAds.hoarding}}</p>
                                    <span class="font-sm my-0">HOARDINGS</span>
                                </div>
                                <!-- <div class="col">
                                    <p class="m-0 text-gray-800 font-weight-bold">{{allAds.campaign}}</p>
                                    <span class="my-0 txt-all">Campaign</span>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 m-0 p-1">
                    <div class="card m-0 p-0  shadow h-100 pointer" (click)="getNewAds()">
                        <div class="">
                            <div class="row m-0 p-0 no-gutters align-items-center">
                                <div class="col p-2 mr-2 border-left-green">
                                    <div class="font-sm font-weight-bold text-uppercase">New Activity</div>
                                    <div class="h3 mb-0 font-weight-bold" *ngIf="newAds">{{newAds.instore+newAds.hoarding}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer p-0">
                            <div class="row m-0 p-2 text-center">
                                <div class="col">
                                    <p class="m-0 text-gray-800 font-weight-bold"  *ngIf="newAds">{{newAds.instore}}</p>
                                    <span class="font-sm my-0">INSTORE</span>
                                </div>
                                <div class="col">
                                    <p class="m-0 text-gray-800 font-weight-bold"  *ngIf="newAds">{{newAds.hoarding}}</p>
                                    <span class="font-sm my-0">HOARDINGS</span>
                                </div>
                                <!-- <div class="col">
                                    <p class="m-0 text-gray-800 font-weight-bold">{{newAds.campaign}}</p>
                                    <span class="my-0 txt-green">Campaign</span>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 m-0 p-1">
                    <div class="card m-0 p-0  shadow h-100 pointer" (click)="getLiveAds(0)">
                        <div class="">
                            <div class="row m-0 p-0 no-gutters align-items-center">
                                <div class="col p-2 border-left-yellow">
                                    <div class="font-sm font-sm font-weight-bold text-uppercase">Current Activity</div>
                                    <div class="h3 mb-0 font-weight-bold"  *ngIf="liveAds">{{liveAds.instore+liveAds.hoarding}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer p-0">
                            <div class="row m-0 p-2 text-center">
                                <div class="col">
                                    <p class="m-0 text-gray-800 font-weight-bold" *ngIf="liveAds">{{liveAds.instore}}</p>
                                    <span class="font-sm my-0">INSTORE</span>
                                </div>
                                <div class="col">
                                    <p class="m-0 text-gray-800 font-weight-bold" *ngIf="liveAds">{{liveAds.hoarding}}</p>
                                    <span class="font-sm my-0 ">HOARDINGS</span>
                                </div>
                                <!-- <div class="col">
                                    <p class="m-0 text-gray-800 font-weight-bold">{{liveAds.campaign}}</p>
                                    <span class="my-0 txt-orange">Campaign</span>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 m-0 p-1">
                    <div class="card shadow h-100 pointer"  (click)="getLiveAds(1)">
                        <div class="">
                            <div class="row m-0 p-0 no-gutters align-items-center">
                                <div class="col p-2 bg-red border-left-orange ">
                                    <div class="font-sm font-weight-bold text-uppercase">
                                       Expiring Activity in 30 days</div>
                                    <div class="h3 mb-0 font-weight-bold" *ngIf="expiredAds">{{instore_expiry30.length + hoarding_expiry30.length}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer p-0">
                            <div class="row m-0 p-2 text-center">
                                <div class="col">
                                    <p class="m-0 text-gray-800 font-weight-bold" *ngIf="expiredAds">{{instore_expiry30.length}}</p>
                                    <span class="font-sm my-0">INSTORE</span>
                                </div>
                                <div class="col">
                                    <p class="m-0 text-gray-800 font-weight-bold" *ngIf="expiredAds">{{hoarding_expiry30.length}}</p>
                                    <span class="font-sm my-0">HOARDINGS</span>
                                </div>
        
                            </div>
                        </div>
                    </div>
                </div> 
                <div class="col-lg-4 m-0 p-1">
                    <div class="card shadow h-100 pointer"  (click)="getExpiryAds()">
                        <div class="">
                            <div class="row m-0 p-0 no-gutters align-items-center">
                                <div class="col p-2 bg-red border-left-red ">
                                    <div class="font-sm font-weight-bold text-uppercase">
                                       Expired Activity</div>
                                    <div class="h3 mb-0 font-weight-bold" *ngIf="expiredAds">{{expiredAds.instore + expiredAds.hoarding}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer p-0">
                            <div class="row m-0 p-2 text-center">
                                <div class="col">
                                    <p class="m-0 text-gray-800 font-weight-bold" *ngIf="expiredAds">{{expiredAds.instore}}</p>
                                    <span class="font-sm my-0">INSTORE</span>
                                </div>
                                <div class="col">
                                    <p class="m-0 text-gray-800 font-weight-bold" *ngIf="expiredAds">{{expiredAds.hoarding}}</p>
                                    <span class="font-sm my-0">HOARDINGS</span>
                                </div>
        
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        <!-- -->
    </div>

    <div class="row m-0 p-1 w-100">     
        <div class="col-lg-12 m-0 p-1">
            <div class="bg-white rounded shadow">

                <div class="col-md-12 row m-0 p-0">
                    <div class="col-md">
                        <div class="title-header"><h5 class="m-0 p-0">DASHBOARD - {{listTitle}}</h5></div>
                    </div>
                    <!-- <div class="col-md grt-include">
                        <form [formGroup]="form">                
                            <div class="row m-0 p-2 justify-content-center" *ngIf="isCurrent" >
                                <input type="checkbox" id="todo" [(ngModel)]="isChecked" (change)="getLiveAds()" formControlName="include" name="todo" value="todo" class="">
                                <label class="m-0 pl-1" for="todo" data-content="Activity Expiring in 30 Days">Activity Expiring in 30 Days</label>
                            </div>
                       </form>
                    </div> -->
                    <div class="col-md p-2">
                        <ul id="myTab" role="tablist" class="justify-content-end nav nav-tabs nav-pills text-center border-0 rounded-nav">
                            <li class="nav-item">
                            <a id="instore-tab" data-toggle="tab" href="#instore" role="tab" aria-controls="instore" aria-selected="true" class="nav-link border-0 text-uppercase font-weight-bold active">Instore</a>
                            </li>
                            <li class="nav-item">
                            <a id="hoarding-tab" data-toggle="tab" href="#hoarding" role="tab" aria-controls="hoarding" aria-selected="false" class="nav-link border-0 text-uppercase font-weight-bold">Hoardings</a>
                            </li>
                            <div class="type-2 my-auto" data-toggle="collapse" data-target="#collapseOne">
                                <div class="text-center">
                                    <a class="btn btn-1">
                                    <span class="txt">filter</span>
                                    <span class="round" ><i class="fa fa-filter fa-md"></i></span>
                                    </a>
                                </div> 
                            </div>
                        </ul> 
                    </div>           
                </div>

                <div id="collapseOne" class="collapse p-2 my-auto" aria-labelledby="headingOne">
                    <form [formGroup]="filterform">
                        <div class="row m-0 header-filter">
                           
                            <div class="col-md-2 d-flex my-auto">
                                <div class="custom-search form-group my-auto">
                                    <input type="filter" formControlName="search" class="custom-search-input" placeholder="Search for" autocomplete="off" tabindex="1" [(ngModel)]="term">
                                </div>
                            </div>
                            <div class="col-md-9 row my-auto">
                                <ng-multiselect-dropdown class="col-sm select-cstyle" 
                                    [placeholder]="'All Assets'"
                                    [settings]="dropdownSettings" formControlName="asset_type_id"
                                    [data]="AssetsDataLists"
                                    (onSelect)="onItemSelect($event)"
                                    (onDeSelect)="onItemDeSelect($event)"
                                    (onSelectAll)="onSelectAll()"
                                    (onDeSelectAll)="onDeSelectAll()">
                                </ng-multiselect-dropdown>
        
                                <ng-multiselect-dropdown class="col-sm select-cstyle"
                                    [placeholder]="'All Creatives'"
                                    [settings]="dropdownSettings"
                                    [data]="CreativeDataLists"
                                    formControlName="creative_id"
                                    (onSelect)="onCreativeItemSelect($event)"
                                    (onDeSelect)="onCreativeItemDeSelect($event)"
                                    (onSelectAll)="onCreativeSelectAll()"
                                    (onDeSelectAll)="onCreativeDeSelectAll()">
                                </ng-multiselect-dropdown>
        
                                <ng-multiselect-dropdown class="col-sm select-cstyle"
                                    [placeholder]="'All Vendors'"
                                    [settings]="dropdownSettings"
                                    [data]="VendorDataLists"
                                    formControlName="vendor_id"
                                    (onSelect)="onVendorItemSelect($event)"
                                    (onDeSelect)="onVendorItemDeSelect($event)"
                                    (onSelectAll)="onVendorSelectAll()"
                                    (onDeSelectAll)="onVendorDeSelectAll()">
                                 </ng-multiselect-dropdown>
        
                            </div>
                            <div class="col-md-1 d-flex my-auto justify-content-end">
                                <div class="">    
                                    <button class="btn btn-reset align-items-center" (click)="clearFilters()"><u>Reset filter</u></button>
                                </div> 
                            </div>  
                        </div>
                    </form>
                </div>

                
              
                <div id="myTabContent" class="tab-content p-2" >
                    <div id="instore" role="tabpanel" aria-labelledby="instore-tab" class="tab-pane fade px-1 show active">
                        <div class="box-table table-responsive p-2">
                            <table class="table box-table table-borderless m-0 p-0" matSort (matSortChange)="sortData($event)" matSortActive="" matSortDirection="asc" matSortDisableClear>
                                <thead class="">
                                    <tr class="justify-content-center ">
                                          <th mat-sort-header = "regionName"><p class="m-0">Region</p></th>
                                          <th mat-sort-header = "showroomName"><p class="m-0">Showroom</p></th>
                                          <th mat-sort-header = "floorName" ><p class="m-0">Floor</p></th>
                                          <th mat-sort-header = "locationName" ><p class="m-0">Location</p></th>
                                          <th mat-sort-header = "assetTypeName" ><p class="m-0">Type</p></th>
                                          <th mat-sort-header = "creativeName" ><p class="m-0">Creative</p></th>
                                          <th mat-sort-header = "vendorName" ><p class="m-0">Vendor</p></th>
                                          <th><p class="m-0">Name</p></th>
                                          <th><p class="m-0">Size</p></th>
                                          <th><p class="m-0">Installation Date</p></th>
                                          <th><p class="m-0">Expiry Date</p></th>
                                          <th mat-sort-header = "expiryDays"><p class="m-0">Expiry Days</p></th>
                                    </tr>
                                </thead>
                
                                <tbody class="">
                                    <tr class="pointer" *ngFor="let data of f_instoreLists| filter:term |slice: (page-1) * pageSize : page * pageSize;let i=index" (click)="callInstoreActivity(data)">
                                        <td><p class="m-0">{{data.regionName}}</p></td>
                                        <td><p class="m-0">{{data.showroomName}}</p></td>
                                        <td><p class="m-0 p-0">{{data.floorName}}</p></td>
                                        <td><p class="m-0">{{data.locationName}}</p></td>
                                        <td><p class="m-0">{{data.assetTypeName}}</p></td>
                                        <td><p class="m-0">{{data.creativeName}}</p></td>
                                        <td><p class="m-0">{{data.vendorName}}</p></td>
                                        <td><p class="text-center  m-0">{{data.name}}</p></td>
                                        <td><p class="text-center  m-0">W {{splitNumber(data.size_w)}} x H {{splitNumber(data.size_h)}}</p> </td>
                                        <td><p class="text-center  m-0">{{data.install_date| date: 'dd/MM/yyyy' }}</p></td>
                                        <td><p class="text-center  m-0">{{data.expiry_date| date: 'dd/MM/yyyy' }}</p></td>
                                        <td><p class="text-center  m-0 font-weight-bold" [ngStyle]="{'color':getColor(data?.expiryDays)}">{{data.expiryDays}}</p></td>
                                    </tr>        
                                </tbody>          
                            </table>
                            <div class="text-center p-5" *ngIf="f_instoreLists && f_instoreLists.length === 0" >
                                <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                    <path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>
                                  </svg>
                                <p class="m-0 no-record"> No Record Found </p>
                            </div>                           
                        </div>
                        <div class="mt-1 sl-pagination text-center justify-content-center d-flex" *ngIf="f_instoreLists && f_instoreLists.length > 5" >
                            <ngb-pagination  [(page)]="page" [maxSize]="5"
                            [pageSize]="pageSize"
                            [collectionSize]="f_instoreLists.length" aria-label="Default pagination" class="pagination pagination-rounded-flat pagination-success"></ngb-pagination>
                        </div>
                    </div>
                    <div id="hoarding" role="tabpanel" aria-labelledby="hoarding-tab" class="tab-pane fade px-1">
                        <div class="box-table table-responsive p-2">
                            <table class="table box-table table-borderless m-0 p-0" matSort (matSortChange)="sortHoardingData($event)" matSortActive="expiryDays" matSortDirection="asc" matSortDisableClear>
                                <thead class="table-light">
                                    <tr class="justify-content-center">
                                        <th mat-sort-header = "regionName"><p class="m-0">Region</p></th>
                                        <th mat-sort-header = "showroomName"><p class="m-0">Showroom</p></th>
                                        <th ><p class="m-0">Area</p></th>
                                        <th ><p class="m-0">Address</p></th>
                                        <th mat-sort-header = "assetTypeName" ><p class="m-0">Type</p></th>
                                        <th mat-sort-header = "creativeName" ><p class="m-0">Creative</p></th>
                                        <th mat-sort-header = "vendorName" ><p class="m-0">Vendor</p></th>
                                        <th><p class="m-0">Name</p></th>
                                        <th><p class="m-0">Size</p></th>
                                        <th><p class="m-0">Sq. Feet</p></th>
                                        <th><p class="m-0">Cost</p></th>
                                        
                                        <th mat-sort-header = "expiryDays"><p class="m-0">Expiry Days</p></th>
                                    </tr>
                                </thead>
                
                                <tbody>
                                    <tr class="pointer" *ngFor="let data of f_hoardingLists| slice: (pageHoardings-1) * pageSizeHoardings : pageHoardings * pageSizeHoardings;let i=index" (click)="callHoardingActivity(data)">
                                        <td><p class="m-0">{{data.regionName}}</p></td>
                                        <td><p class="m-0">{{data.showroomName}}</p></td>
                                        <td><p class="text-center m-0 p-0">{{data.area}}</p></td>
                                        <td><p class="text-center m-0 p-0">{{data.address}}</p></td>

                                        <td><p class="m-0">{{data.assetTypeName}}</p></td>
                                        <td><p class="m-0">{{data.creativeName}}</p></td>
                                        <td><p class="m-0">{{data.vendorName}}</p></td>
                                        <td><p class="text-center m-0">{{data.name}}</p></td>
                                        <td><p class="text-center m-0">W {{splitNumber(data.size_w)}} x H {{splitNumber(data.size_h)}}</p>
                                        <td><p class="text-center m-0">{{splitNumber(data.size_w * data.size_h)}}</p>
                                        <td><p class="text-center m-0">{{data.cost| currency:'INR'}}</p></td>
                                        <td><p class="text-center m-0 font-weight-bold"  [ngStyle]="{'color':getColor(data?.expiryDays)}">{{data.expiryDays}}</p></td>
                                    </tr>
                                 
                                </tbody> 
                               
                            </table>
                            <div class="text-center p-5" *ngIf="f_hoardingLists && f_hoardingLists.length === 0" >
                                <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                    <path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>
                                  </svg>
                                <p class="m-0 no-record"> No Record Found </p>
                            </div>        
                        </div>
                        <div class="sl-pagination text-center justify-content-center d-flex" *ngIf="f_hoardingLists && f_hoardingLists.length > 10" >
                            <ngb-pagination  [(page)]="pageHoardings"  [maxSize]="5"
                            [pageSize]="pageSizeHoardings"  *ngIf="f_hoardingLists.length > 10"
                            [collectionSize]="f_hoardingLists.length" aria-label="Default pagination" class="pagination pagination-rounded-flat pagination-success"></ngb-pagination>
                        </div>
                    </div>
                
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="row m-0 p-1 w-100" *ngIf="isCurrent">
        <div class="col-md m-0 p-1">
                <div class="justify-content-end  d-flex parent-box mt-2">
                    <div class="box-instore shadow pointer" (click)="getLiveAds()">
                        <div class="top-solid solid-red d-flex justify-content-center align-items-center">
                          {{instore_expiry30.length}}
                        </div>  
                        <div class="label-value d-flex justify-content-center align-items-center text-center">
                            <p class="">Expiry in 30 Days</p>
                        </div>  
                    </div>
                
                </div>
            </div>
    </div> -->
</div>
